import React from 'react';
import openFeedback from 'utils/feedbackify';
import styles from './style.module.scss';
import Button from 'components/control/button';
import { buildClassName } from 'utils/build-class-name';

export type FeedbackButtonProps = {
  className?: string;
};

/** Button to open the Feedback form */
export default function FeedbackButton({ className }: FeedbackButtonProps) {
  return <Button label="Send Us Feedback" expHomePadding={false} onClick={openFeedback} theme='secondary' className={buildClassName(styles.feedback, className)} />;
}
